import { parentLoginRequest, parentLogoutRequest, parentRegisterRequest } from '../api/parentAuth.api';

export const registerParent = async (data) => {
  const res = await parentRegisterRequest(data);
  return res.data;
};

export const loginParent = async (data) => {
  const res = await parentLoginRequest(data);
  return res.data;
};

export const logoutParent = async (refreshToken) => {
  const res = await parentLogoutRequest({ refresh_token: refreshToken });
  return res.data;
};
